import { jsxs as i, jsx as l } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as C } from "./index.es2359.js";
function e({ size: t = C }) {
  return /* @__PURE__ */ i(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: t,
      height: t,
      viewBox: "0 0 56 56",
      fill: "none",
      children: [
        /* @__PURE__ */ l("rect", { width: "56", height: "56", rx: "3", fill: "#F2DFE1" }),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M41 28C41 35.1797 35.1797 41 28 41C20.8203 41 15 35.1797 15 28C15 20.8203 20.8203 15 28 15C35.1797 15 41 20.8203 41 28Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M29.0457 30.6027L29.4828 21.7448H26.5171L26.9542 30.6027H29.0457Z",
            fill: "#B00020"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M28 34.2552C28.6904 34.2552 29.25 33.6956 29.25 33.0052C29.25 32.3149 28.6904 31.7552 28 31.7552C27.3096 31.7552 26.75 32.3149 26.75 33.0052C26.75 33.6956 27.3096 34.2552 28 34.2552Z",
            fill: "#B00020"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28 41C35.1797 41 41 35.1797 41 28C41 20.8203 35.1797 15 28 15C20.8203 15 15 20.8203 15 28C15 35.1797 20.8203 41 28 41ZM28 40C34.6274 40 40 34.6274 40 28C40 21.3726 34.6274 16 28 16C21.3726 16 16 21.3726 16 28C16 34.6274 21.3726 40 28 40Z",
            fill: "#B00020"
          }
        )
      ]
    }
  );
}
e.__tags = [];
export {
  e as MetricErrorIcon
};
//# sourceMappingURL=index.es416.js.map
